import { Component } from '@verndale/core';
import { ElementOrSelector, stagger, timeline, scroll } from 'motion';
import { TimelineDefinition } from '@motionone/dom/types/timeline/types';
import { debounce } from '../helpers';

class ProductLayers extends Component {
  breakpoint = false;
  reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  constructor(el: HTMLElement) {
    super(el);
    this.breakpoint = window.matchMedia(`(min-width: ${1024}px)`).matches;
    if (!this.reducedMotion.matches) {
      this.setInitialStyles();
      this.setAnimationSequence();
    }
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      layerList: this.el.querySelector<HTMLElement>(
        '.product-layers__cards-list'
      ),
      layers: this.el.querySelectorAll('.product-layers__layer'),
      productCardsItems: this.el.querySelectorAll(
        '.product-layers__product-card-item'
      ),
      layersAndCardsContainer: this.el.querySelector<HTMLElement>(
        '.product-layers__layers-and-cards-container'
      )
    };
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.handlePageResize.bind(this), 300)
    );
  }

  handlePageResize() {
    if (
      window.matchMedia(`(min-width: ${1024}px)`).matches !== this.breakpoint &&
      !this.reducedMotion.matches
    ) {
      this.breakpoint = window.matchMedia(`(min-width: ${1024}px)`).matches;
      this.dom.layers = (this.dom.el as HTMLElement).querySelectorAll(
        '.product-layers__layer'
      );
      this.setInitialStyles();

      requestAnimationFrame(() => {
        this.setAnimationSequence();
      });
    }
  }

  setInitialStyles() {
    let maxHeight = 0;
    //card layers height
    [].forEach.call(this.dom.layers, (layer: HTMLElement) => {
      if (layer.clientHeight > maxHeight) maxHeight = layer.clientHeight;
    });

    if (this.breakpoint) {
      [].forEach.call(this.dom.layers, (layer: HTMLElement) => {
        layer.removeAttribute('style');
      });
    } else {
      [].forEach.call(this.dom.layers, (layer: HTMLElement) => {
        layer.style.blockSize = `${maxHeight}px`;
      });
    }

    //card items
    [].forEach.call(
      this.dom.productCardsItems,
      (productCardItem: HTMLElement, i: number) => {
        productCardItem.style.opacity = '0';
        productCardItem.style.transform = this.breakpoint
          ? `translateX(${i % 2 === 0 ? '50px' : '-50px'})`
          : `translateX(0)`;
        productCardItem.style.top = '20px';
      }
    );
  }

  setAnimationSequence() {
    const sequence = [] as TimelineDefinition;

    [].forEach.call(this.dom.layers, (layer: HTMLElement, i: number) => {
      sequence.push([
        layer as ElementOrSelector,
        {
          transform: [
            this.breakpoint
              ? `translate(0, calc(-${i * 50}% + ${27 * i}px))`
              : `translate(0, calc(-${i * 100}% + ${10 * i}px))`,
            'translate(0, 0)'
          ]
        },
        { duration: 10, at: 0 }
      ]);
    });

    // //card items
    sequence.push([
      this.dom.productCardsItems as ElementOrSelector,
      { opacity: [0, 1], transform: 'translateX(0)', top: '0' },
      {
        duration: 2,
        easing: 'linear',
        delay: this.breakpoint ? stagger(0.5) : stagger(4),
        at: 0,
        opacity: { duration: this.breakpoint ? 1 : 2 },
        transform: { duration: 3.5 },
        top: { duration: 0.25 }
      }
    ]);

    scroll(timeline(sequence, { duration: 5 }), {
      target: this.dom.layersAndCardsContainer as HTMLElement,
      offset: [
        `start ${this.breakpoint ? '0.45' : '0.45'}`,
        `end ${this.breakpoint ? 'end' : '-0.5'}`
      ]
    });
  }
}

export default ProductLayers;
